export enum ModeEnum {
  mailRead,
  mailCompose,
  office,
  contentManager,
  contentManagerAdvancedSearch,
  contentManagerTeams
}